import * as yup from "yup";
import { CHARACTERS_LIMIT_EXCEEDED } from "../../constants/formconstants";

export const helpFeedbackFormSchema = yup.object().shape({
  comment: yup.string().max(500, CHARACTERS_LIMIT_EXCEEDED(500)),
});
